var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTelegram(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3258 5.61292L3.87673 11.186C2.89056 11.5816 2.8964 12.1317 3.69698 12.377L7.30063 13.5017L8.67947 17.7292C8.8471 18.1918 8.76447 18.3754 9.25034 18.3754C9.6253 18.3754 9.79164 18.2044 10.0005 18.0004C10.1333 17.8704 10.9218 17.1038 11.8022 16.2478L15.5507 19.0174C16.2404 19.3979 16.7385 19.2008 16.9102 18.3768L19.3708 6.78153C19.6228 5.77154 18.9858 5.31341 18.3258 5.61292ZM7.86618 13.2433L15.9888 8.11869C16.3943 7.87277 16.7661 8.00498 16.4609 8.27596L9.50575 14.5512L9.23494 17.4396L7.86618 13.2433Z",
    fill: "#A7A7BB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTelegram);
export default __webpack_public_path__ + "static/media/ic_telegram.db952703e61951b56edd6df66026341d.svg";
export { ForwardRef as ReactComponent };